/* AAMPLIFIED conversion layer: cart drawer, quick add, product form, sets, delivery dates. No dependencies. */
(function () {
  if (window.AAX && window.AAX.ready) return;
  var A = window.AAX = window.AAX || {};
  A.ready = true;
  var SID = 'aax-cart-drawer';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  A.money = function (cents) { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: currency }); };

  /* ---------- Cart drawer ---------- */
  function drawer() { return document.getElementById('aax-cart'); }
  var lastFocus = null;
  A.open = function () {
    var d = drawer();
    if (!d) { location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    d.hidden = false;
    void d.offsetWidth;
    d.classList.add('is-open');
    document.documentElement.classList.add('aax-lock');
    var c = d.querySelector('[data-aax-close]');
    if (c) c.focus({ preventScroll: true });
  };
  A.close = function () {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('aax-lock');
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  function setCount(n) {
    $$('[data-aax-count]').forEach(function (el) { el.textContent = n; if (n > 0) el.removeAttribute('data-zero'); else el.setAttribute('data-zero', ''); });
    $$('.cart-count').forEach(function (el) { el.textContent = n; });
  }
  function paint(html) {
    var d = drawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.aax-cart__panel');
    var old = d.querySelector('.aax-cart__panel');
    if (!fresh || !old) return;
    old.innerHTML = fresh.innerHTML;
    setCount(+fresh.getAttribute('data-count') || 0);
    etas(old);
  }
  function busy(on) { var d = drawer(); if (d) d.classList.toggle('is-busy', on); }
  function post(url, body) {
    body.sections = SID;
    body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Try again.'); return j; }); });
  }
  A.refresh = function () {
    return fetch(location.pathname + '?sections=' + SID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (j) { paint(j[SID]); });
  };
  A.add = function (items, opts) {
    opts = opts || {};
    busy(true);
    return post('/cart/add.js', { items: items })
      .then(function (j) {
        paint(j.sections && j.sections[SID]);
        document.dispatchEvent(new CustomEvent('aax:added', { detail: { items: items } }));
        if (opts.open !== false) A.open();
        return j;
      })
      .finally(function () { busy(false); });
  };
  A.change = function (line, qty) {
    busy(true);
    return post('/cart/change.js', { line: line, quantity: qty })
      .then(function (j) { paint(j.sections && j.sections[SID]); })
      .catch(function () { return A.refresh(); })
      .finally(function () { busy(false); });
  };
  // Legacy Plain Jane code calls these.
  window.openCartDrawer = A.open;
  window.updateCart = A.refresh;

  /* ---------- Delivery dates (business days, store time) ---------- */
  function storeToday() {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Phoenix', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var g = function (t) { return +p.filter(function (x) { return x.type === t; })[0].value; };
      return new Date(g('year'), g('month') - 1, g('day'));
    } catch (e) { var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
  }
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w !== 6) n--; } return d; }
  var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
  function etas(scope) {
    var today = storeToday();
    $$('[data-aax-eta]', scope).forEach(function (el) {
      el.textContent = fmt(addBiz(today, +el.dataset.min || 7)) + ' – ' + fmt(addBiz(today, +el.dataset.max || 12));
    });
    $$('[data-aax-cutoff]', scope).forEach(function (el) {
      var parts = (el.dataset.aaxCutoff || '').split('-');
      if (parts.length !== 3) return;
      var last = new Date(+parts[0], +parts[1] - 1, +parts[2]);
      var days = Math.round((last - today) / 864e5);
      if (days < 0 || days > (+el.dataset.window || 30)) return;
      el.hidden = false;
      var left = el.querySelector('[data-days]');
      if (left) left.textContent = days === 0 ? 'today' : days === 1 ? 'tomorrow' : last.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) + ' (' + days + ' days)';
    });
  }

  /* ---------- Product form ---------- */
  function sel(groups) { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
  function match(variants, s) { if (s.indexOf(null) !== -1) return null; return variants.filter(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); })[0] || null; }
  function markAvail(groups, variants) {
    var s = sel(groups);
    groups.forEach(function (g, gi) {
      $$('input', g).forEach(function (inp) {
        var ok = variants.some(function (v) {
          if (!v.available || v.options[gi] !== inp.value) return false;
          return v.options.every(function (o, i) { return i === gi || s[i] === null || s[i] === o; });
        });
        inp.nextElementSibling.classList.toggle('is-out', !ok);
      });
      var c = $('input:checked', g), out = $('[data-aax-chosen]', g);
      if (out) out.textContent = c ? c.value : (g.dataset.prompt || '');
    });
  }
  function initProduct(buy) {
    if (buy.dataset.ready) return;
    var form = $('form.aax-pform, form[data-aax-form]', buy);
    var btn = $('[data-aax-atc]', buy);
    var json = $('[data-aax-json]', buy);
    if (!form || !btn || !json) return;
    buy.dataset.ready = '1';
    var data = JSON.parse(json.textContent);
    var msg = $('[data-aax-msg]', buy) || document.createElement('p');
    var idInput = $('input[name=id]', form);
    var mainGroups = $$('[data-aax-main] [data-aax-opt]', buy);
    var partnerGroups = $$('[data-aax-partner] [data-aax-opt]', buy);
    var sticky = buy.hasAttribute('data-no-url') ? null : document.querySelector('[data-aax-sticky]');
    var partnerTouched = false;

    function mode() { return buy.dataset.mode || 'single'; }
    function state() {
      var m = match(data.variants, sel(mainGroups));
      var p = mode() === 'set' && data.partner ? match(data.partner.variants, sel(partnerGroups)) : null;
      return { main: m, partner: p };
    }
    function render(changedGroup) {
      markAvail(mainGroups, data.variants);
      if (data.partner) markAvail(partnerGroups, data.partner.variants);
      var st = state(), isSet = mode() === 'set' && data.partner;
      var base = st.main || data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
      var label, price = base.price, compare = base.compare > base.price ? base.compare : 0, disabled = false;
      if (isSet) {
        var pb = st.partner || data.partner.variants[0];
        compare = base.price + pb.price;
        price = data.setPrice;
      }
      if (st.main && !st.main.available) { label = 'Sold out'; disabled = true; }
      else if (isSet && st.partner && !st.partner.available) { label = data.partner.title + ' sold out in that size'; disabled = true; }
      else if (!st.main || (isSet && !st.partner)) { label = isSet ? 'Select your sizes' : 'Select a size'; }
      else { label = (isSet ? 'Add the set' : 'Add to cart') + ' · ' + A.money(price); }
      btn.innerHTML = label + (compare > price && !disabled && label.indexOf('Add') === 0 ? ' <s>' + A.money(compare) + '</s>' : '');
      btn.disabled = disabled;
      $$('[data-aax-price]', buy).forEach(function (el) {
        el.innerHTML = A.money(price) + (compare > price ? ' <s>' + A.money(compare) + '</s>' : '');
      });
      if (st.main) {
        idInput.value = st.main.id;
        if (!buy.hasAttribute('data-no-url')) {
          var u = new URL(location.href);
          u.searchParams.set('variant', st.main.id);
          history.replaceState(history.state, '', u.toString());
        }
        if (changedGroup && !changedGroup.hasAttribute('data-size') && st.main.media) {
          var fig = document.querySelector('[data-media-id="' + st.main.media + '"]');
          if (fig && fig.parentElement) {
            var gal = fig.parentElement;
            if (gal.scrollWidth > gal.clientWidth) gal.scrollTo({ left: fig.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
          }
        }
      }
      if (sticky) {
        var sb = $('.aax-btn', sticky), sp = $('[data-aax-sticky-price]', sticky);
        if (sb) sb.textContent = !st.main || (isSet && !st.partner) ? 'Choose size' : disabled ? 'Sold out' : (isSet ? 'Add set' : 'Add to cart');
        if (sb) sb.disabled = disabled;
        if (sp) sp.textContent = A.money(price) + (isSet ? ' · full set' : '');
      }
    }
    function missing() {
      var groups = mainGroups.concat(mode() === 'set' ? partnerGroups : []);
      return groups.filter(function (g) { return !$('input:checked', g); });
    }
    buy.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'aax-mode') { buy.dataset.mode = t.value; msg.textContent = ''; render(); return; }
      var g = t.closest('[data-aax-opt]');
      if (!g) return;
      g.classList.remove('is-missing');
      msg.textContent = '';
      var inPartner = !!t.closest('[data-aax-partner]');
      if (inPartner) partnerTouched = true;
      else if (g.hasAttribute('data-size') && !partnerTouched) {
        partnerGroups.forEach(function (pg) {
          if (!pg.hasAttribute('data-size')) return;
          var twin = $$('input', pg).filter(function (i) { return i.value === t.value; })[0];
          if (twin) { twin.checked = true; pg.classList.remove('is-missing'); }
        });
      }
      render(g);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var miss = missing();
      if (miss.length) {
        miss.forEach(function (g) { g.classList.add('is-missing'); });
        msg.textContent = miss.length > 1 ? 'Pick both sizes first.' : 'Pick your size first.';
        miss[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var st = state();
      if (!st.main) return;
      var props = {};
      new FormData(form).forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; });
      var items = [{ id: st.main.id, quantity: 1, properties: props }];
      if (mode() === 'set' && st.partner) items.push({ id: st.partner.id, quantity: 1 });
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      A.add(items).then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.disabled = false; render(); }, 1400);
      }).catch(function (err) {
        btn.disabled = false;
        btn.innerHTML = original;
        msg.textContent = err.message;
      });
    });
    if (sticky) {
      var sbtn = $('.aax-btn', sticky);
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else btn.click();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var r = en[0];
          sticky.classList.toggle('is-on', !r.isIntersecting && r.boundingClientRect.top < 0);
        }).observe(btn);
      }
    }
    render();
  }

  /* ---------- Gallery dots ---------- */
  function initGallery(gal) {
    if (gal.dataset.ready) return;
    gal.dataset.ready = '1';
    var dots = gal.nextElementSibling && gal.nextElementSibling.matches('.aax-gallery__dots') ? $$('span', gal.nextElementSibling) : [];
    if (!dots.length) return;
    var tick = false;
    gal.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        tick = false;
      });
    }, { passive: true });
  }

  /* ---------- Recommendations ---------- */
  function initRecs(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    fetch(el.dataset.url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-aax-recs]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.hidden = false; }
    }).catch(function () {});
  }

  /* ---------- Load more (collections) ---------- */
  function loadMore(btn) {
    var grid = document.querySelector(btn.dataset.target);
    btn.disabled = true;
    btn.textContent = 'Loading…';
    fetch(btn.dataset.next, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = doc.querySelector(btn.dataset.target);
      if (g) Array.prototype.forEach.call(g.children, function (c) { grid.appendChild(document.importNode(c, true)); });
      var nb = doc.querySelector('[data-aax-more]');
      if (nb) { btn.dataset.next = nb.dataset.next; btn.disabled = false; btn.textContent = nb.textContent; }
      else btn.parentElement.remove();
    }).catch(function () { btn.disabled = false; btn.textContent = 'Load more'; });
  }

  /* ---------- Signup (Klaviyo client API) ---------- */
  function signup(form) {
    var email = form.querySelector('input[type=email]').value.trim();
    var out = form.parentElement.querySelector('[data-aax-signup-msg]');
    var b = form.querySelector('button');
    b.disabled = true;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + form.dataset.company, {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Website signup', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: form.dataset.list } } } } })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      form.hidden = true;
      if (out) { out.textContent = out.dataset.ok; out.className = 'aax-signup__ok'; }
    }).catch(function () { b.disabled = false; if (out) out.textContent = 'That did not go through. Check the email and try again.'; });
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var opener = t.closest('[data-aax-open-cart], .cart-text');
    if (opener && drawer()) { e.preventDefault(); e.stopImmediatePropagation(); A.open(); return; }
    if (t.closest('[data-aax-close]') || t.classList.contains('aax-cart__scrim')) { A.close(); return; }
    var q = t.closest('[data-aax-qty]');
    if (q) { A.change(+q.dataset.line, +q.dataset.aaxQty); return; }
    var qa = t.closest('[data-aax-qa]');
    if (qa) {
      e.preventDefault();
      var card = qa.closest('.aax-card');
      if (qa.dataset.id) {
        qa.disabled = true;
        A.add([{ id: +qa.dataset.id, quantity: 1 }]).catch(function (err) { alert(err.message); }).finally(function () { qa.disabled = false; if (card) card.classList.remove('is-qa'); });
      } else if (card) {
        $$('.aax-card.is-qa').forEach(function (c) { if (c !== card) c.classList.remove('is-qa'); });
        card.classList.add('is-qa');
      }
      return;
    }
    if (t.closest('[data-aax-qa-close]')) { e.preventDefault(); var c2 = t.closest('.aax-card'); if (c2) c2.classList.remove('is-qa'); return; }
    var sg = t.closest('[data-aax-sg]');
    if (sg) { var dlg = document.getElementById('aax-sg'); if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); } return; }
    if (t.closest('[data-aax-dialog-close]') || (t.tagName === 'DIALOG' && t.classList.contains('aax-dialog'))) { var dd = t.closest('dialog'); if (dd) dd.close(); return; }
    var mt = t.closest('[data-aax-menu]');
    if (mt) { var nav = document.getElementById('aax-mnav'); if (nav) { var on = !nav.hasAttribute('open'); nav.toggleAttribute('open', on); document.documentElement.classList.toggle('aax-lock', on); $$('[data-aax-menu][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', on); }); } return; }
    var more = t.closest('[data-aax-more]');
    if (more) { e.preventDefault(); loadMore(more); }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-aax-upform]')) {
      e.preventDefault();
      var b = f.querySelector('button');
      b.disabled = true;
      A.add([{ id: +f.querySelector('[name=id]').value, quantity: 1 }]).catch(function (err) { alert(err.message); b.disabled = false; });
    } else if (f.matches('[data-aax-signup]')) { e.preventDefault(); signup(f); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    A.close();
    var nav = document.getElementById('aax-mnav');
    if (nav && nav.hasAttribute('open')) { nav.removeAttribute('open'); document.documentElement.classList.remove('aax-lock'); }
    $$('.aax-card.is-qa').forEach(function (c) { c.classList.remove('is-qa'); });
  });

  /* ---------- Boot ---------- */
  function boot(scope) {
    scope = scope || document;
    $$('[data-aax-product]', scope).forEach(function (b) { try { initProduct(b); } catch (err) { console.error('AAX product', err); } });
    $$('.aax-gallery', scope).forEach(initGallery);
    $$('[data-aax-recs-src]', scope).forEach(initRecs);
    etas(scope);
    var rev = $$('.aax-reveal:not(.is-in)', scope);
    if ('IntersectionObserver' in window && rev.length) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      rev.forEach(function (r) { io.observe(r); });
    } else rev.forEach(function (r) { r.classList.add('is-in'); });
  }
  A.boot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) A.refresh(); });
})();
